import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import {Grid} from "@mui/material";
import {Trans, useTranslation} from "react-i18next";

function Copyright() {
  const {t} = useTranslation();
  return (
    <Typography
      variant="body2"
      align="center"
      sx={{
        color: "text.secondary",
      }}>
      <Trans
        t={t}
        i18nKey="footer.copyright"
        values={{year: new Date().getFullYear()}}
        components={{siteLink: <Link color="inherit" href="https://okwind.fr/" />}}
      />
    </Typography>
  );
}

function Privacy() {
  const {t} = useTranslation();
  return (
    <Typography
      variant="body2"
      align="center"
      sx={{
        color: "text.secondary",
      }}>
      <Link color="inherit" href="/privacy_okwind.html" target="_blank" rel="noopener">
        {t("footer.privacyPolicy")}
      </Link>
    </Typography>
  );
}

export default function Footer() {
  return (
    <Box component="footer" style={{marginTop: "-20px"}} sx={{py: 2}}>
      <Grid
        container
        columnSpacing={12}
        sx={{
          columnGap: 2,
          justifyContent: "center",
        }}>
        <Grid>
          <Privacy />
        </Grid>
        <Grid>
          <Copyright />
        </Grid>
      </Grid>
    </Box>
  );
}
